import "./_hero.scss";
import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", () => {
  const heroSliderGalleryContainer = document.querySelectorAll(
    ".hero-slider-gallery",
  );
  heroSliderGalleryContainer.forEach((slider) => {
    new Swiper(slider, {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 3000, // ms tra un'immagine e l'altra
        disableOnInteraction: false,
      },
      speed: 800,
      allowTouchMove: false,
    });
  });
});
